import type { FC } from 'react';

import { StyledPriceGroupBadge } from './PriceGroupBadge.styled';

interface IPriceGroupBadgeProps {
	priceGroupName?: string;
	dataTestId?: string;
}

/** Highlights the price group of a discounted ticketshop ticket. */
export const PriceGroupBadge: FC<IPriceGroupBadgeProps> = ({
	priceGroupName,
	dataTestId,
}) => {
	if (!priceGroupName) {
		return null;
	}

	return (
		<StyledPriceGroupBadge variant="l2" data-testid={dataTestId}>
			{priceGroupName}
		</StyledPriceGroupBadge>
	);
};
